import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import RowDetail from "../components/detail/RowDetail";
import RowDetailListLibelle from "../components/detail/RowDetailListLibelle";

// Styles:

interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc5: React.FC<IProps> = ({ NoticeResult }) => {
  const ListProduiLivre = ['TPLIV', 'TPIAD', 'TPPOC', 'TPREV', 'TPCOF', 'TPCAR'];
  const ListAudioFilmMusique = ['TPAUD','TPFIL','TPMUS','TPLOG']
  const ListidSupportTPEBO = ['IFA', 'IFS', 'IFN']
  let physicalDescription = null;
  let coffret = null;
  let pocheIcon = null;
  let epaisseur = null;
  let poids = null;
  let LogicielEducatifAudioFilmMusique = null;
  let duree = null
  let supportIFA_IFS_IFN = null;
  let supportIdIFM = null;
  function getFormat (formatEbook : any, poidsEbook : any) {
    if (poidsEbook) {
      return `1 fichier ${formatEbook} - ${poidsEbook} (Mo)`;
    } else {
      return `1 fichier ${formatEbook}`
    }
  }
  function getVenduSeul (venduSeul : string) {
    if (venduSeul.toLocaleLowerCase() === 'false') {
      return `Non`;
    } else {
      return `Oui`
    }
  }
  if (NoticeResult) {
    if (ListProduiLivre.includes(NoticeResult.typeProduitId)) {
      physicalDescription = (
        <>
            {NoticeResult.DesciptionPhysique?.reliure && (<><i>{NoticeResult.DesciptionPhysique?.reliure}</i>;</>)} 
            {NoticeResult.DesciptionPhysique?.nbVolumes !== undefined && NoticeResult.DesciptionPhysique?.nbVolumes > 0 && (<i> {NoticeResult.DesciptionPhysique?.nbVolumes}</i>)}
            {NoticeResult.DesciptionPhysique?.typeVolume && (<i> {NoticeResult.DesciptionPhysique?.typeVolume}</i>)}
            {NoticeResult.DesciptionPhysique?.nbPages && (<> (<i>{NoticeResult.DesciptionPhysique?.nbPages}</i> p.)</>)}
            {(NoticeResult.DesciptionPhysique?.nbVolumes || NoticeResult.DesciptionPhysique?.typeVolume || NoticeResult.DesciptionPhysique?.nbPages) && (<>;</>)}
            {NoticeResult.DesciptionPhysique?.mentionIllustrations && (<> <i>{NoticeResult.DesciptionPhysique?.mentionIllustrations}</i>;</>)} 
            {(NoticeResult.DesciptionPhysique?.hauteur !== undefined && NoticeResult.DesciptionPhysique?.largeur !== undefined &&
              NoticeResult.DesciptionPhysique?.hauteur > 0 && NoticeResult.DesciptionPhysique?.largeur > 0) && (
              <>
                <i> {NoticeResult.DesciptionPhysique?.hauteur}</i> x <i>{NoticeResult.DesciptionPhysique?.largeur}</i> cm
              </>
            )}
        </>
      );
      if (NoticeResult?.coffret) {
        coffret = (
          <div>
            <svg width="20" height="20" version="1.1" viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">
              <path d="M101.86,20.7,98.18,30l68.59,27.11a59.35,59.35,0,0,1-27.07,14.7L66.2,43.63l-6.21,6v130.9l80,29.79,1.42-.3c16.76-3.55,31.24-14.24,37.6-22.67l1-1.34V51.59ZM170,182.6c-5.68,6.7-17,14.36-29.3,17.34L70,173.61V55.79L138.86,82.2l1.43-.28A71.21,71.21,0,0,0,170,67.64ZM80,79.91l49.93,20.38V110L80,90Zm0,30,49.93,20.38v9.75L80,120.06Zm0,30.13,30,12.3v9.75L80,150.18Z"/>
            </svg>
              <i>Coffret</i>
          </div>
        );
      }
      if (NoticeResult?.libelleTypeProduit === 'Poche') {
        pocheIcon = (
              <div>
                <svg width="20" height="20" version="1.1" viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">
                  <path d="M120,30a90,90,0,1,1-90,90,90.11,90.11,0,0,1,90-90m0-10A100,100,0,1,0,220,120,100,100,0,0,0,120,20ZM100,180H90V65.15L94.88,65c1,0,23.4-.57,34.19,1,20.8,3,31.35,14.08,31.35,33,0,29.78-24.24,34.85-31.67,35.7-9.2,1-26.6.83-28.74.8Zm0-54.51c.94,0,18.84.26,27.61-.74,8.51-1,22.8-5.6,22.8-25.76,0-13.92-6.81-20.83-22.76-23.11-7.1-1-20.46-1-27.65-1Z"/>
                </svg>
                <i> {NoticeResult?.libelleTypeProduit}</i>
              </div>
        );
      }
      if (NoticeResult?.DesciptionPhysique?.epaisseur !== null && NoticeResult?.DesciptionPhysique?.epaisseur !== 0) {
        epaisseur = (
          <RowDetail titre="Epaisseur" donnee={NoticeResult?.DesciptionPhysique?.epaisseur} suffixe=" cm" />
        )
      }
      if (NoticeResult?.DesciptionPhysique?.poids !== null && NoticeResult?.DesciptionPhysique?.poids !== 0) {
        poids = (
          <RowDetail titre="Poids" donnee={NoticeResult?.DesciptionPhysique?.poids} suffixe=" g" />
        )
      }      
    } else if (ListAudioFilmMusique.includes(NoticeResult.typeProduitId)) {
      if (NoticeResult.DesciptionPhysique !== null ) {
        if (NoticeResult?.DesciptionPhysique?.duree !== null && NoticeResult.DesciptionPhysique?.duree !== '') {
          duree = (
            <>
              ({NoticeResult.DesciptionPhysique?.duree})
            </>
          )
      }
      LogicielEducatifAudioFilmMusique = (
        <i>{NoticeResult.DesciptionPhysique?.nbVolumes} {NoticeResult.DesciptionPhysique?.typeVolume} {duree}</i>
      )
      }
      
    } else if (NoticeResult.typeProduitId === 'TPEBO') {

      supportIdIFM = (
        <>
        {NoticeResult.Bloc3?.descriptionsEbook?.packEbookContenus?.length !== 0 && NoticeResult.Bloc3?.descriptionsEbook?.packEbookContenus &&
        (
          <>
           <div className="row">
            <div className={`col-4 pae-detail-label"}`} style={{ textAlign: 'left' }}>
              <b>Contient :</b>
            </div>
          </div>
          </>
        )}
        {NoticeResult.Bloc3?.descriptionsEbook?.packEbookContenus?.map((item, index) => (
          <>
          <div style={{marginLeft: '5%'}}>
              {item.formatEbookContenu && (
                <div className="row">
                <div className={`col-4 pae-detail-label"}`} style={{ textAlign: 'left' }}>
                  {index + 1 }. <b>{item.formatEbookContenu}</b>
                </div>
              </div>
              )}
              {item.eanEbookContenu && (
                <RowDetail titre="EAN" donnee={item.eanEbookContenu} />
              )}
              {item.formatEbookContenu && (
                <RowDetail titre="Format" donnee={getFormat(item.formatEbookContenu,item.poidsEbookContenu)} />
              )}
              {item.protectionEbookContenu && (
                <RowDetail titre="protection" donnee={item.protectionEbookContenu} />
              )}
              {item.droitsEbookContenu && item.droitsEbookContenu.length !== 0 && (
                <RowDetailListLibelle titre="Condition" donnees={item.droitsEbookContenu?.map(x => x.limitation)} libelles={item.droitsEbookContenu?.map(x => x.utilisation)} />
              )}
              {item.descriptionEbookContenu && (
                <RowDetail titre="Description" donnee={item.descriptionEbookContenu} />
              )}
              {item.venduSeul && (
                <RowDetail titre="Vendu séparément" donnee={getVenduSeul(item.venduSeul)} />
              )}
          </div>
         <br></br>
          </>
        ))}
        </>
      )
    }
    supportIFA_IFS_IFN = (
      <>
        {NoticeResult.Bloc3?.descriptionsEbook?.formatEbook && (

          <RowDetail titre="Format" donnee={`${NoticeResult.Bloc3?.descriptionsEbook?.caracteristiqueFormat} (${getFormat(NoticeResult.Bloc3?.descriptionsEbook?.formatEbook,NoticeResult.Bloc3?.descriptionsEbook?.poidsEbook)})`} />
        )}
        {NoticeResult.Bloc3?.descriptionsEbook?.protectionEbook && (
          <RowDetail titre="Protection" donnee={NoticeResult.Bloc3?.descriptionsEbook?.protectionEbook} />
        )}
        {/* {NoticeResult.Bloc3?.descriptionsEbook?.poidsEbook && (
          <RowDetail titre="Poids" donnee={NoticeResult.Bloc3?.descriptionsEbook?.poidsEbook} />
        )} */}
        {NoticeResult.Bloc3?.descriptionsEbook?.droitsEbook && NoticeResult.Bloc3?.descriptionsEbook?.droitsEbook?.length !== 0 && (
          <RowDetailListLibelle titre="Droits utilisateur:" donnees={NoticeResult.Bloc3?.descriptionsEbook?.droitsEbook?.map(x => x.limitation)} libelles={NoticeResult.Bloc3?.descriptionsEbook?.droitsEbook?.map(x => x.utilisation)} />
        )}
      </>
    );
  }


  return (
    <>
      <div className="card" style={{ textAlign: 'left' }}>
        <div className="col-sm-12 card-body">
          {supportIdIFM}
          <RowDetail titre="Support" donnee={NoticeResult?.Support?.libelleSupport} />
          {NoticeResult.Bloc3?.descriptionsEbook?.packEbookContenus?.length !== 0 && NoticeResult.Bloc3?.descriptionsEbook?.packEbookContenus && (
                <RowDetail
                  titre="Format"
                  donnee={NoticeResult?.Bloc3?.descriptionsEbook?.caracteristiqueFormat}
                />
            )}
          <RowDetail titre="" elem={physicalDescription} />
          {NoticeResult.DesciptionPhysique?.materielsAccompagnement && NoticeResult.DesciptionPhysique?.materielsAccompagnement?.length > 0 && 
              (<RowDetail titre="Matériel accompagnement" donnee={NoticeResult.DesciptionPhysique?.materielsAccompagnement[0]} />)}
          <RowDetail titre="" elem={coffret} />
          <RowDetail titre="" elem={pocheIcon} />
          {epaisseur}
          {poids}
          <RowDetail titre="" elem={LogicielEducatifAudioFilmMusique} />
          {ListidSupportTPEBO.includes(NoticeResult.Support.supportId) && (
          <>
            {supportIFA_IFS_IFN}
          </>
          )}
        </div>
      </div>
      <br />
    </>
  );
};

export default Bloc5;
